import { render, staticRenderFns } from "./Picking.vue?vue&type=template&id=0fbf0c08&scoped=true&"
import script from "./Picking.vue?vue&type=script&lang=js&"
export * from "./Picking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf0c08",
  null
  
)

export default component.exports